import moment from 'moment';
import { RSAA } from 'redux-api-middleware';
import * as A from '../actions/candidateAccountRecoveryActions';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';


const { getDataType } = ssCommonUtils;

export const
toggleModalPasswordResetRequest = () => ({ type: A.TOGGLE_PASSWORD_RESET_MODAL }),
updateCandRecoveryStepStatus = (step, status) => ({ type: A.UPDATE_RECOVERY_STEP_STATUS, payload: { step, status }}),
clearCandidateRecoveryData = () => ({ type: A.CLEAR_CANDIDATE_RECOVERY_DATA }),
clearCandidateRecoveryRequest = () => ({ type: A.CLEAR_CANDIDATE_RECOVERY_REQUEST }),
candidateRecoverySubmission = (form, captcha) => {
    const
    { candidateRecoverEmail, candidatePassport, candidatePersonal} = form,
    replaceEmptyStringsInObject = data => {
        switch(getDataType(data)) {
            case 'Object':
                for(let p in data)
                    switch(getDataType(data[p])) {
                        case 'Object': data[p] = replaceEmptyStringsInObject(data[p]); break;
                        case 'String': if(data[p].length === 0) data[p] = null; break;
                    }
                break;
            case 'String':
                if(data.length === 0) data = null; break;
        }
        return data;
    };

    return { [RSAA]: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        endpoint: '/user/recovery',
        body: JSON.stringify(replaceEmptyStringsInObject({
            captcha: captcha,
            firstName: candidatePersonal.firstName,
            lastName: candidatePersonal.lastName,
            middleName: candidatePersonal.middleName,
            nameSuffixCD: candidatePersonal.nameSuffix,
            dob: candidatePersonal.dob,
            dobTypeCD: candidatePersonal.dobType,
            phoneNumber: candidatePersonal.phoneNumber,
            passportTypeCD: candidatePassport.passportType,
            passportNumber: candidatePassport.passportNumber,
            issueDate: candidatePassport.issueDate,
            expirationDate: candidatePassport.expirationDate,
            issuingCountry: candidatePassport.issuingCountry,
            city: candidatePassport.city,
            userName: candidateRecoverEmail.userId,
            oldEmailAddress: candidateRecoverEmail.oldEmailAddress,
            newEmailAddress: candidateRecoverEmail.newEmailAddress,
            }
        )),
        types: [
            A.CANDIDATE_RECOVERY_SUBMISSION_PENDING,
            A.CANDIDATE_RECOVERY_SUBMISSION_SUCCESS,
            A.CANDIDATE_RECOVERY_SUBMISSION_FAILURE
        ]
    }}
};
